<template>
  <button
    :style="{
      textAlign: 'left',
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      padding: '14px',
      cursor: 'pointer',
      fontFamily: 'inherit',
      borderRadius: '14px',
      border: `1px solid ${selected ? 'var(--p-primary-500)' : 'var(--p-content-border-color)'}`,
      background: selected ? 'var(--p-highlight-background)' : 'var(--p-content-background)',
    }"
    @click="emit('click')"
    @dblclick="emit('dblclick')"
  >
    <RecordMonogram :record="record" :config="config" ratio="4 / 3" />
    <div :style="{ minWidth: 0 }">
      <div :style="{ fontWeight: 700, fontSize: '15.5px', color: 'var(--p-text-color)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }">
        {{ config.primary(record) }}
      </div>
      <div :style="{ marginTop: '6px', fontSize: '12.5px' }">
        <FormatValue v-if="key0" :record="record" :field-key="key0" :field-definitions="fieldDefinitions" :field-meta="fieldMeta" />
      </div>
    </div>
  </button>
</template>

<script setup>
// Grid tile: 4:3 media + title + first field. Ported from collection-frame
// GridTile. Emits click / dblclick.
import { computed } from 'vue'
import RecordMonogram from './RecordMonogram.vue'
import FormatValue from '@/admin-collection-layout/lib/formatValue.js'

const props = defineProps({
  record: { type: Object, required: true },
  config: { type: Object, required: true },
  fieldDefinitions: { type: Object, required: true },
  fieldMeta: { type: Object, default: () => ({}) },
  selected: { type: Boolean, default: false },
  cols: { type: Array, default: null },
})
const emit = defineEmits(['click', 'dblclick'])

const key0 = computed(() => (props.cols || props.config.columns || [])[0])
</script>
